<template>
  <div class="flex items-center justify-between gap-2">
    <div
      class="inline-flex w-fit rounded-xl bg-slate-100 p-1"
      role="group"
      aria-label="Timeline period"
    >
      <button
        v-for="option in periodOptions"
        :key="option.value"
        type="button"
        class="rounded-lg px-2.5 py-1 text-sm font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-heroblue-500 focus-visible:ring-offset-2 xs:px-4"
        :class="periodType === option.value ? 'bg-white text-heroblue-600 shadow-sm' : 'text-slate-500 hover:text-slate-700'"
        :aria-pressed="periodType === option.value"
        @click="$emit('update:periodType', option.value)"
      >
        {{ option.label }}
      </button>
    </div>

    <u-select-menu
      v-model="selectedSortOption"
      :options="sortOptions"
      :ui-menu="{width: 'w-max min-w-[180px]'}"
    >
      <div class="flex cursor-pointer flex-nowrap items-center gap-1 text-xs font-semibold xs:gap-2 xs:text-sm">
        <span class="text-nowrap text-text-light">Sort by:</span>
        <span class="text-nowrap text-heroblue-700">{{ selectedSortOption.label }}</span>
        <u-icon name="i-ri-arrow-down-s-line" class="shrink-0 text-lg text-heroblue-700" />
      </div>
    </u-select-menu>
  </div>
</template>

<script setup>
  const props = defineProps({
    periodType: {
      type: String,
      required: true
    },
    sortOrder: {
      type: String,
      required: true
    }
  });

  const emit = defineEmits(['update:periodType', 'update:sortOrder']);

  const periodOptions = [
    {label: 'Decades', value: 'decade'},
    {label: 'Years', value: 'year'}
  ];

  const sortOptions = [
    {label: 'Newest to Oldest', value: 'newest-to-oldest'},
    {label: 'Oldest to Newest', value: 'oldest-to-newest'}
  ];

  const selectedSortOption = computed({
    get: () => sortOptions.find(option => option.value === props.sortOrder) || sortOptions[0],
    set: option => emit('update:sortOrder', option.value)
  });

</script>
